
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DelDialog from "./delete-dialog.vue";
import Pop from "../components/blue-pop.vue";
import {
  AllOptionText,
  HeaderOption,
  Video,
  ExamV3,
  QuestionP,
  ErrorRule,
  UseRule
} from "@/lib/model/workerbuilder/exam-v3";
import { MutiChoiceOption } from "@/lib/model/exambuilder/exam-v2";

@Component({
  components: { DelDialog, Pop }
})
export default class RegidEdit extends Vue {
  @Prop({}) param!: HeaderOption; //当前考察项
  @Prop({}) paramKey!: string; //考察项名
  @Prop({}) editIndex!: number; //编辑时 index 判重用
  @Prop({}) exam!: ExamV3; //考察项名
  // @Prop({ type: UseRule }) option?: UseRule; //多选
  rules = {
    optionName: [
      { required: true, message: "请输入考察项名称", trigger: "change" }
      // { max: 12, message: "最多12个字符", trigger: "blur" }
    ],
    "param.name": [
      { required: true, message: "请输入题目", trigger: "change" }
    ],
    "param.inputType": [
      { required: true, message: "请选择考察方式", trigger: "change" }
    ]
  };
  defaultResListVideo = [
    {
      title: "通过",
      text: "候选人得分符合要求",
      status: 0
    },
    {
      title: "未通过",
      text: "候选人得分未达到岗位要求",
      status: 1
    },
    {
      title: "未作答",
      text: "候选人未参加(包括中途退出)",
      status: 1
    }
  ];

  editParam = new HeaderOption(); //编辑用
  AllOptionText = new AllOptionText().op; //全部文案
  videoList: Video[] = [];
  questionList: QuestionP[] = []; //文化考试题配置
  showQuestion = false;

  show(item: any) {
    return this.AllOptionText?.[item.type] || ["通用视频"].includes(item.type);
  }

  created() {
    this.editParam = new HeaderOption().assign(this.param); //复制一份 编辑用
    if (["形象素质", "沟通表达", "通用视频"].includes(this.paramKey)) {
      this.getVedioList(true);
    }
    if (["文化考试测试"].includes(this.paramKey)) {
      this.getQuestion();
    }
    if (["通用多选"].includes(this.paramKey)) {
      this.setMultiData();
    }
    if (["新建"].includes(this.paramKey)) {
      this.getNew();
    }
  }
  //编辑多选时
  setMultiData() {
    //自动展开 说明文案
    this.editParam.param.mutiChoiceOptions.forEach(d => {
      d.showDesc = Boolean(d.desc);
    });
  }
  //切换单多选
  changeType(value: string) {
    if (value === "choice") {
      this.getNew();
    } else {
      this.getNewMulti();
    }
  }
  //单选初始化
  getNew() {
    this.editParam.param.inputType = "choice";
    this.editParam.param.singleChoiceOptions = ["", ""];
    this.editParam.param.mutiChoiceOptions = [];
    this.editParam.paramErrorRuleList = [new ErrorRule(), new ErrorRule()];
  }
  //多选初始化
  getNewMulti() {
    this.editParam.param.inputType = "multiChoice";
    this.editParam.param.singleChoiceOptions = [];
    this.editParam.param.mutiChoiceOptions = [
      new MutiChoiceOption(),
      new MutiChoiceOption(),
      new MutiChoiceOption()
    ];
    //判定规则
    this.editParam.paramErrorRuleList = [
      new ErrorRule(),
      new ErrorRule(),
      new ErrorRule()
    ];
    //使用lv
    this.editParam.paramUseRuleList = [
      new UseRule(),
      new UseRule(),
      new UseRule()
    ];
  }
  //自定义 相关****
  delOption(i: number, multi = "") {
    if (multi === "multi") {
      //多选
      this.editParam.param.mutiChoiceOptions.splice(i, 1);
      this.editParam.paramUseRuleList.splice(i, 1);
    } else {
      //单选
      this.editParam.param.singleChoiceOptions.splice(i, 1);
    }
    this.editParam.paramErrorRuleList.splice(i, 1);
  }
  addOption(multi = "") {
    if (multi === "multi") {
      //多选
      this.editParam.param.mutiChoiceOptions.push(new MutiChoiceOption());
      this.editParam.paramUseRuleList.push(new UseRule());
    } else {
      //单选
      this.editParam.param.singleChoiceOptions.push("");
    }
    this.editParam.paramErrorRuleList.push(new ErrorRule());
  }

  //文化考试相关
  getQuestion() {
    ExamV3.getQuestion({}).then(res => {
      if (res.data.code === 0) {
        res.data?.data?.list?.forEach((d: any) => {
          //设置 题数 分值
          d.questionNumber = 0;
          d.questionScore = 0;
        });
        this.questionList = res.data.data.list;
        this.showQuestion = true;
      }
    });
  }
  //题型对应信息
  getQuestionInfo(q: any): QuestionP {
    return (
      this.questionList.find((res: QuestionP) => {
        return res?.dimensionName === q?.dimensionName;
      }) || new QuestionP()
    );
  }
  //***视频题相关****
  getVedioList(first = false) {
    Video.getList({ dimension: this.param.optionName }).then(res => {
      if (res.data.code === 0) {
        //设置已选
        res.data?.data?.list?.forEach((d: any) => {
          d.checked = this.editParam.videoQuestionIdList.includes(d.questionId)
            ? true
            : false;
        });
        // if (first) {
        //   res.data.data.list[0].checked = true;
        // }
        this.videoList = res.data.data.list;
      }
    });
  }
  checkVideo() {
    //变动存editParam里
    this.editParam.videoQuestionIdList = [];
    this.videoList.forEach(d => {
      if (d.checked) {
        this.editParam.videoQuestionIdList.push(d.questionId);
      }
    });
    console.log(this.editParam.videoQuestionIdList);
    console.log(this.videoList);
  }
  addVideo() {
    const v = new Video();
    v.editing = true;
    this.videoList.push(v);
  }
  saveVideo(it: Video) {
    if (!it.descTextOnly) return;
    it.editing = false;
    Video.create({ descTextOnly: it.descTextOnly }).then(res => {
      if (res.data.code === 0) {
        this.$message.success("添加成功");
        this.getVedioList();
      }
    });
  }
  delVideo(it: Video) {
    Video.delete({ questionId: it.questionId }).then(res => {
      if (res.data.code === 0) {
        this.$message.success("删除成功");
        this.getVedioList();
      }
    });
  }
  delVideoAdd(i: number) {
    this.videoList.splice(i, 1);
  }
  //****** end */

  editCancel() {
    this.$emit("cancel");
  }
  async editOk() {
    if (["形象素质", "沟通表达", "通用视频"].includes(this.paramKey)) {
      if (
        this.videoList.find(v => {
          return v.editing;
        })
      ) {
        this.$message.warning("请先保存正在编辑的题目");
        return;
      }
      if (!this.editParam.videoQuestionIdList.length) {
        this.$message.warning("请选择至少一道题目");
        return;
      }
      // const vIdList: number[] = [];
      // this.videoList.forEach((element) => {
      //   if (element.checked) {
      //     vIdList.push(element.questionId);
      //   }
      // });
      // this.editParam.videoQuestionIdList = vIdList;
    }
    if (["年龄要求"].includes(this.paramKey)) {
      if (
        Number(this.editParam.ageRange[0]) > Number(this.editParam.ageRange[1])
      ) {
        this.$message.warning("请设置合理的年龄要求范围");
        return;
      }
    }
    if (["文化考试测试"].includes(this.paramKey)) {
      const SL = this.editParam.singleChoiceList;
      const used = SL.find((d, i) => {
        return d.questionNumber > 0;
      });
      //第一个被选的维度的类型
      const one = this.getQuestionInfo(used).isStdDimension;
      if (
        SL.some((d, i) => {
          return (
            d.questionNumber > 0 &&
            this.getQuestionInfo(d).isStdDimension !== one
          );
        })
      ) {
        this.$message.warning("不能混合选择默认题目与自定义题目");
        return;
      }
      if (this.total().score !== 100) {
        this.$message.warning("请配置考试总分为100分");
        return;
      }
    }
    if (["新建", "通用单选", "通用多选"].includes(this.paramKey)) {
      let resOk = false;
      await (this.$refs.formDiy as any).validate((valid: boolean) => {
        if (valid) {
          // 考察项名称判重
          const flag = this.exam.headerOptions.find((n, i) => {
            return (
              [n.type, n.optionName].includes(this.editParam.optionName) &&
              i !== this.editIndex
            );
          });
          if (flag) {
            this.$message.warning("考察项名称重复");
            resOk = false;
            return;
          }

          //多选选项全局判重
          let ii = this.editParam.param.mutiChoiceOptions.length;
          this.editParam.param.mutiChoiceOptions.forEach((m, j) => {
            ii += this.exam.headerOptions.findIndex((n, i) => {
              return m.key === n.type;
            });
          });
          if (ii > 0) {
            this.$message.warning("选项内容与考察项名称重复");
            resOk = false;
            return;
          }
          //选项去空
          if (this.editParam.param.inputType === "choice") {
            if (
              this.editParam.paramErrorRuleList.every(d => {
                return d.errorRule === 0;
              })
            ) {
              resOk = false;
              this.$message.warning("请至少选择一个评估规则");
              return;
            }
            if (
              !this.editParam.param.singleChoiceOptions.some(d => {
                return d;
              })
            ) {
              resOk = false;
              this.$message.warning("请至少输入一个选项");
              return;
            }
            for (
              let i = 0;
              i < this.editParam.param.singleChoiceOptions.length;
              i++
            ) {
              if (!this.editParam.param.singleChoiceOptions[i]) {
                this.delOption(i);
                i--;
              }
            }
          }
          if (this.editParam.param.inputType === "multiChoice") {
            if (
              !this.editParam.param.mutiChoiceOptions.some(d => {
                return d.key;
              })
            ) {
              resOk = false;
              this.$message.warning("请至少输入一个选项");
              return;
            }
            for (
              let i = 0;
              i < this.editParam.param.mutiChoiceOptions.length;
              i++
            ) {
              if (!this.editParam.param.mutiChoiceOptions[i].key) {
                this.delOption(i, "multi");
                i--;
              }
            }
          }

          this.editParam.edit = true; //是可编辑
          this.editParam.type =
            this.editParam.param.inputType === "choice"
              ? "通用单选"
              : "通用多选";
          // this.editParam.pType = this.editParam.type;
          this.editParam.pType = "个人信息及岗位要求";
          //单选 补全异常项 name
          this.editParam.param.singleChoiceOptions.forEach((d, i) => {
            if (this.editParam.paramErrorRuleList?.[i]) {
              this.editParam.paramErrorRuleList[i].keyName = d;
            }
          });
          //多选
          if (this.editParam.param.inputType === "multiChoice") {
            // 补全异常项 和 使用规则 name
            this.editParam.paramUseRuleList.forEach((p, i) => {
              p.keyName = this.editParam.param.mutiChoiceOptions[i].key;
              if (this.editParam.paramErrorRuleList?.[i]) {
                this.editParam.paramErrorRuleList[i].keyName = p.keyName;
              }
              //仅收集信息的 设为不考察
              if (this.editParam.paramErrorRuleList[i].errorRule === 0) {
                p.useLevel = 0;
              }
            });
          }
          console.log(this.editParam);
          resOk = true;
          return;
        } else {
          resOk = false;
          return;
        }
      });
      if (!resOk) return;
    }
    //吐回
    this.$emit("save", this.editParam);
  }
  //互斥
  multiOnly(i: number) {
    this.editParam.param.mutiChoiceOptions.forEach((d: any, j: number) => {
      if (i === j) {
        d.type = d.type === "unsetOthers" ? "" : "unsetOthers";
      } else {
        d.type = "";
      }
    });
  }
  total() {
    const res = { number: 0, score: 0 };
    this.editParam.singleChoiceList.forEach(d => {
      res.number += d.questionNumber;
      res.score += d.questionScore * d.questionNumber;
    });
    return res;
  }
}
